import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from '@services/subscription';
import { SubscriptionPlanTemplate } from '@models/subscription';

interface UseAllSubscriptionPlansOptions {
  enabled?: boolean;
}

/**
 * Fetches ALL subscription plan templates, including PRIVATE plans and add-ons.
 * Backed by the SUPER_ADMIN-only `getAllSubscriptionPlans` query.
 *
 * Use this in admin flows (e.g. assigning a plan to an organization) where
 * private plans must be selectable. For public signup flows use
 * `useSubscriptionPlans`, which returns public plans only.
 */
export const useAllSubscriptionPlans = (
  options?: UseAllSubscriptionPlansOptions,
) => {
  return useQuery<SubscriptionPlanTemplate[]>({
    queryKey: ['allSubscriptionPlans'],
    queryFn: async () => {
      const response = await subscriptionService.getAllSubscriptionPlans();
      return response;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - admin may have just created a plan
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 1,
    enabled: options?.enabled !== false,
  });
};
